WiseMetering.Views.WaterbeepIntegrationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'waterbeep',

    createTable: function() {
        this.collection = this.model.integrations();

        this.table = new WiseMetering.Views.Table({
            id: 'integrations',
            collection: this.collection,
            disableSelect: !WiseMetering.currentUser.isSuperUser(),
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    siteName: model.site().get('name'),
                    consent: i18next.t(`common.${model.get('consent') ? 'yes' : 'no'}`),
                    id: model.id,
                    lastProcessedFile: model.get('last_processed_file') || '-',
                    name: model.get('name'),
                    reference: model.get('reference'),
                    state: { color, state },
                    lastRunAt: model.get('last_run_at') ? WiseMetering.utils.formatDate(model.get('last_run_at')) : '-',
                    updatedAt: WiseMetering.utils.formatDate(model.get('updated_at'))
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                name: i18next.t('common.name'),
                siteName: i18next.t('glossary.site'),
                reference: i18next.t('integrations.local_code'),
                consent: `${i18next.t('integrations.consent')}?`,
                lastProcessedFile: i18next.t('integrations.last_processed_file'),
                lastRunAt: i18next.t('integrations.last_run_at'),
                updatedAt: i18next.t('glossary.last_change')
            },
            toolbar_actions: {
                new: {
                    label: i18next.t('ui.actions.new'),
                    permission: 'superuser',
                    view_call: () => new WiseMetering.Views.NewWaterbeepIntegration({
                        collection: WiseMetering.integrations,
                        license: this.model,
                        model: new WiseMetering.Model.Integration({ license_id: this.model.id })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.EditWaterbeepIntegration({ model })
                },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => Backbone.history.navigate(`/integrations/${model.id}/details`, { trigger: true })
                },
                rebuild: {
                    permission: 'superuser',
                    icon: 'rebuild',
                    label: i18next.t('ui.actions.rebuild'),
                    view_call: model => new WiseMetering.Views.RebuildIntegration({ model })
                },
                disable: {
                    icon: 'disable',
                    label: i18next.t('ui.actions.disable'),
                    permission: 'superuser',
                    view_call: model => {
                        if (model.get('state') !== 'active') {
                            return;
                        }

                        new WiseMetering.Views.DisableIntegration({ model });
                    }
                },
                enable: {
                    icon: 'enable',
                    label: i18next.t('ui.actions.enable'),
                    permission: 'superuser',
                    view_call: model => {
                        if (model.get('state') === 'active') {
                            return;
                        }

                        new WiseMetering.Views.EnableIntegration({ model });
                    }
                },
                delete: {
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                        model,
                        title: () => i18next.t('modal.title.integrations.destroy')
                    })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
